import { AnyAction } from '@reduxjs/toolkit'

import type { Currency } from 'utils/currency'
import type { FetchStatusCommon } from 'restApi/types'

type EnquiryData = {
  start_date: string
  end_date: string
  adults: number
  children: number
  total_guests: number
  customer_service_fee: string
  tax_amount: string
  tax_rate_details: {
    name: string
    rate: string
    juris_type: string
    included: boolean
  }
  total: string
  hint: string
  currency: Currency
  line_items: [
    {
      item_type: string
      price: string
      quantity: number
      amount: string
      details: [
        {
          label: string
          price: string
        },
      ]
    },
  ]
  listing: {
    id: number
    status: string
    price: string
    pricing_suffix: string
    extra_person_fee: string
    extra_person_threshold: number
    capacity: number
    listing_type: {
      id: number
      name: string
      slug: string
      active: true
    }
  }
  errors: []
}

type EnquiryState = FetchStatusCommon & {
  data: EnquiryData
  creating: boolean
  updating: boolean
}

const initialState: EnquiryState = {
  fetching: false,
  fetched: false,
  data: null,
  error: null,
  creating: false,
  updating: false,
  updated: false,
  submitting: false,
}

export default function reducer(
  state = initialState,
  action: AnyAction,
): EnquiryState {
  switch (action.type) {
    case 'BOOKING_ENQUIRY_CREATE_PENDING': {
      return {
        ...state,
        creating: true,
      }
    }

    case 'BOOKING_ENQUIRY_CREATE_REJECTED': {
      return {
        ...state,
        creating: false,
        error: action.payload,
      }
    }

    case 'BOOKING_ENQUIRY_CREATE_FULFILLED': {
      return {
        ...state,
        creating: false,
        error: undefined,
      }
    }

    case 'ENQUIRY_RESET_PRICES': {
      return initialState
    }

    case 'ENQUIRY_FETCH_PRICES_PENDING': {
      return {
        ...state,
        fetching: true,
      }
    }

    case 'ENQUIRY_FETCH_PRICES_REJECTED': {
      return {
        ...state,
        fetching: false,
        error: action.payload,
      }
    }

    case 'ENQUIRY_FETCH_PRICES_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: action.payload.data,
      }
    }

    default: {
      return state
    }
  }
}
